import React, {FunctionComponent, useState} from 'react';

import HanButton from '../../../utils/HanButton';
import EditCard from '../../layout/EditCard';
import {toast, ToastContentProps} from 'react-toastify';
import SubjectArea from '../../../../networking/models/SubjectArea';
import SubjectAreaCard from '../../partials/subject-area/SubjectAreaCard';
import {useSubjectAreaDeleteMutation, useSubjectAreaSaveMutation} from '../../../query/SubjectArea/Mutation';

interface NewSubjectArea {
    number: number;
}

interface Props {
    subjectAreas: SubjectArea[];
}

const SubjectAreasContent: FunctionComponent<Props> = (props) => {

    const subjectAreaSaveMutation = useSubjectAreaSaveMutation();
    const subjectAreaDeleteMutation = useSubjectAreaDeleteMutation();

    const [newSubjectAreas, setNewSubjectAreas] = useState<NewSubjectArea[]>([]);

    const addSubjectArea = () => {
        setNewSubjectAreas([...newSubjectAreas, { number: Math.random() }]);
    };

    const onSubjectAreaSave = async (name: string, number: number) => {
        await saveSubjectArea({ name });
        deleteNewSubjectArea(number);
    };

    const onNewSubjectAreaDelete = (number: number) => {
        deleteNewSubjectArea(number);
    };

    const deleteNewSubjectArea = (number: number) => {
        const newState = [...newSubjectAreas];

        const index = newState.findIndex(u => u.number === number);
        newState.splice(index, 1);

        setNewSubjectAreas(newState);
    };

    const saveSubjectArea = async (subjectArea: SubjectArea) => {
        await toast.promise(subjectAreaSaveMutation.mutateAsync(subjectArea), {
            pending: `Saving subject ${subjectArea.name}`,
            success: `Saved subject ${subjectArea.name}!`,
            error: `Error saving subject!`
        });
    };

    const deleteSubjectArea = async (subjectArea: SubjectArea) => {
        await toast.promise(subjectAreaDeleteMutation.mutateAsync(subjectArea), {
            pending: `Deleting subject ${subjectArea.name}`,
            success: `Deleted subject ${subjectArea.name}!`,
            error: { render: (e: ToastContentProps<any>) => e.data?.message || `Error deleting subject!` }
        });
    };

    return (
        <>
            <h1 className={'admin-subject-areas-page__title'}>Subject Areas</h1>

            <HanButton onClick={addSubjectArea}>Add SubjectArea</HanButton>

            <div className={'admin-subject-areas-page__subject-areas'}>
                { newSubjectAreas.map(newUser => (
                    <EditCard
                        value={''}
                        open={true}
                        onChange={(email) => onSubjectAreaSave(email, newUser.number)}
                        onDelete={() => onNewSubjectAreaDelete(newUser.number)}
                        key={newUser.number} />
                )) }

                { props.subjectAreas.map(subjectArea => (
                    <SubjectAreaCard
                        subjectArea={subjectArea}
                        onChange={subjectArea => saveSubjectArea(subjectArea)}
                        onDelete={deleteSubjectArea}
                        key={subjectArea.id} />
                )) }
            </div>
        </>
    );
};

export default SubjectAreasContent;
